import { useApolloClient } from '@apollo/client';
import { isObject } from 'lodash';
import { useCallback } from 'react';
import { type DealerFragmentFragment } from '../../../api/fragments/DealerFragment';
import { type UploadFileWithPreviewFormDataFragment } from '../../../api/fragments/UploadFileWithPreviewFormData';
import {
    DeleteDealerSocialMediaAssetDocument,
    type DeleteDealerSocialMediaAssetMutation,
    type DeleteDealerSocialMediaAssetMutationVariables,
} from '../../../api/mutations/deleteDealerSocialMediaAsset';
import {
    UploadDealerSocialMediaAssetDocument,
    type UploadDealerSocialMediaAssetMutation,
    type UploadDealerSocialMediaAssetMutationVariables,
} from '../../../api/mutations/uploadDealerSocialMediaAsset';
import { DealerAsset } from '../../../api/types';

const useHandleDealerAsset = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (
            dealerSocialMediaId: string,
            values: UploadFileWithPreviewFormDataFragment | File,
            initialValues?: DealerFragmentFragment
        ) => {
            const media = initialValues?.contact.socialMedia.find(list => list.id === dealerSocialMediaId);

            if (values instanceof File) {
                await apolloClient.mutate<
                    UploadDealerSocialMediaAssetMutation,
                    UploadDealerSocialMediaAssetMutationVariables
                >({
                    mutation: UploadDealerSocialMediaAssetDocument,
                    variables: { dealerSocialMediaId, type: DealerAsset.Icon, upload: values },
                });
            } else if (values === null && isObject(media?.icon)) {
                await apolloClient.mutate<
                    DeleteDealerSocialMediaAssetMutation,
                    DeleteDealerSocialMediaAssetMutationVariables
                >({
                    mutation: DeleteDealerSocialMediaAssetDocument,
                    variables: { dealerSocialMediaId, type: DealerAsset.Icon },
                });
            }
        },
        [apolloClient]
    );
};

export default useHandleDealerAsset;
